import React, {useEffect, useState} from 'react';
import DocumentTemplateFillOutComponent from 'features/documentTemplate/DocumentTemplateFillOutComponent';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '../../store/store';
import {DocumentTemplate} from '../../types/documentTemplate';
import {useParams} from 'react-router-dom';
import {DocumentTemplateSolutionThunks} from '../../features/documentTemplateSolution/documentTemplateSolutionThunks';

const DocumentTemplateAdminFillOutPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [documentTemplate, setDocumentTemplate] = useState<DocumentTemplate>(
    new DocumentTemplate({}),
  );
  const [solutionId, setSolutionId] = useState<string>('');
  const [ownerType, setOwnerType] = useState<
    'UserApplication' | 'UserEvaluation'
  >('UserApplication');
  const {id} = useParams<{id: string}>();

  useEffect(() => {
    const loadData = async () => {
      const search = {
        where: {
          id: {
            operator: '==',
            value: id,
          },
        },
      };
      const response = await dispatch(
        DocumentTemplateSolutionThunks.index({search: search}),
      );
      if (response.payload && response.payload.data.length > 0) {
        const solution = response.payload.data[0];
        const documentTemplate = new DocumentTemplate(solution.snapshot);
        setDocumentTemplate(documentTemplate);
        setSolutionId(solution.id);
        setOwnerType(
          solution.owner_type as 'UserApplication' | 'UserEvaluation',
        );
      } else {
        alert('Could not fetch template data.');
      }
    };
    loadData();
  }, [id]);

  return (
    <div>
      <DocumentTemplateFillOutComponent
        mode={'admin'}
        buttonText={'Approve'}
        documentTemplate={documentTemplate}
        solutionId={solutionId}
        ownerType={ownerType}
      />
    </div>
  );
};

export default DocumentTemplateAdminFillOutPage;
